module.exports = "/_next/static/images/eedd7cf246ea71785b536b61c090f2db-right-side-desktop.jpg";